import React from "react";
import OverlayType from "./constants/overlay-type";
import BankIdOverlay from "./overlays/bankid/index";
import CreditAssessmentBankIdOverlay from "./overlays/bankid/credit-assessment-bankid";
import CreditAssessmentScoringOverlay from "./overlays/credit-assessment-scoring/index";
const MissingOverlay = (props) => (React.createElement("button", { "data-ecom-button": "full-width", onClick: props.onHideOverlay }, "Tillbaka"));
export default (props) => {
    switch (props.type) {
        case OverlayType.BANK_ID:
            return React.createElement(BankIdOverlay, Object.assign({}, props));
        case OverlayType.CREDIT_ASSESSMENT_BANK_ID:
            return React.createElement(CreditAssessmentBankIdOverlay, Object.assign({}, props));
        case OverlayType.CREDIT_ASSESSMENT_SCORING:
            return React.createElement(CreditAssessmentScoringOverlay, Object.assign({}, props));
        default:
            return React.createElement(MissingOverlay, { onHideOverlay: props.onHideOverlay });
    }
};
